"use strict";

export function subscribe(eventType, callback) {
    $(document).on(eventType, callback);
}

export function publish(eventType, payload) {
    $(document).trigger(eventType, payload);
}